import { runtimeEnv } from "./runtimeEnv";

const client = runtimeEnv.REACT_APP_PRODUCT_NAME;

const BRAND_COLOR_PRESETS = {
  default: {
    main: "#005b96",
    secondary: "#0072BC",
    third: "#005b96",
    fourth: "#ffffff",
  },
  goib: {
    main: "#004B99",
    secondary: "#0066CC",
    third: "#3c3c3b",
    fourth: "#ffffff",
  },
  edna: {
    main: "#CC3333",
    secondary: "#821A1A",
    third: "#E2E0DC",
    fourth: "#ffffff",
  },
};

const brandTheme = (runtimeEnv.REACT_APP_BRAND_THEME || "default").toLowerCase();
const presetColors = BRAND_COLOR_PRESETS[brandTheme] || BRAND_COLOR_PRESETS.default;
const BRAND_ASSET_PRESETS = {
  default: {
    client: "CLIENT_A",
    logo: "DSB.jpg",
    logoSecondary: null,
    logoThird: null,
    logoFourth: "logo192.png",
  },
  goib: {
    client: "CLIENT_C",
    logo: "BALEAR_B.svg",
    logoSecondary: "NextGenerationW.png",
    logoThird: "PRTRW.png",
    logoFourth: "BALEAR_W.svg",
  },
  edna: {
    client: "CLIENT_B",
    logo: "EDNA.png",
    logoSecondary: "NextGeneration.png",
    logoThird: "PRTR.png",
    logoFourth: "EDNA3.png",
  },
};
const presetAssets = BRAND_ASSET_PRESETS[brandTheme] || BRAND_ASSET_PRESETS.default;
const BRAND_LANGUAGE_PRESETS = {
  default: {
    languages: ["es", "en", "ca", "eu", "gl"],
    defaultLang: "es",
    fallbackLang: "en",
  },
  goib: {
    languages: ["es", "ca", "en"],
    defaultLang: "es",
    fallbackLang: "en",
  },
  edna: {
    languages: ["es", "en"],
    defaultLang: "es",
    fallbackLang: "en",
  },
};
const presetLanguages =
  BRAND_LANGUAGE_PRESETS[brandTheme] || BRAND_LANGUAGE_PRESETS.default;
const configuredLanguages = runtimeEnv.REACT_APP_LANGUAGES?.split(",")
  .map((lang) => lang.trim())
  .filter(Boolean);

const toAssetPath = (assetName, fallback) => {
  if (assetName) {
    return `/assets/${assetName}`;
  }

  if (!fallback) {
    return null;
  }

  return `/assets/${fallback}`;
};

export const appConfig = {
  brandTheme,
  client: client || presetAssets.client || "CLIENT_A",
  colors: {
    main: runtimeEnv.REACT_APP_MAIN_COLOR || presetColors.main,
    secondary: runtimeEnv.REACT_APP_SECONDARY_COLOR || presetColors.secondary,
    third: runtimeEnv.REACT_APP_THIRD_COLOR || presetColors.third,
    fourth: runtimeEnv.REACT_APP_FOURTH_COLOR || presetColors.fourth,
  },
  logo: toAssetPath(runtimeEnv.REACT_APP_LOGO, presetAssets.logo),
  logoSecondary: toAssetPath(
    runtimeEnv.REACT_APP_LOGO_SECONDARY,
    presetAssets.logoSecondary,
  ),
  logoThird: toAssetPath(runtimeEnv.REACT_APP_LOGO_THIRD, presetAssets.logoThird),
  logoFourth: toAssetPath(
    runtimeEnv.REACT_APP_LOGO_FOURTH,
    presetAssets.logoFourth,
  ),
  languages: {
    available:
      configuredLanguages && configuredLanguages.length > 0
        ? configuredLanguages
        : presetLanguages.languages,
    default: runtimeEnv.REACT_APP_DEFAULT_LANG || presetLanguages.defaultLang,
    fallback: runtimeEnv.REACT_APP_FALLBACK_LANG || presetLanguages.fallbackLang,
  },
};
